<template>
  <section id="executiveAdvisoryBoard">
    <div class="container">
      <h2>Executive Advisory Board</h2>
      <div class="board">
        <div v-for="boardMember in board">
          <h5 v-html="boardMember.name"></h5>
          <p v-html="boardMember.organization"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'executive-advisory-board',
  props: ['board']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-color: $gold;
  text-align: center;
}

h2 {
  color: $brand-primary;
  margin-bottom: 3rem;
}

.board {
  @include media('tablet') {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 30%;
    }
  }
  > div {
    margin-bottom: 1rem;
    @include media('tablet') {
      margin-right: 5%;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  h5 {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ExecutiveAdvisoryBoard.vue?0940b4dd